(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('classy').component('egPayDigitalWallets', {
  templateUrl: 'global/embedded-giving/pay/components/digital-wallets/eg.pay.components.digital-wallets', // same folder as this
  bindings: {
    frequency: '<',
    amount: '<',
    fot: '<',
    classyMode: '<',
    currency: '<',
    submit: '<',
    payType: '='
  },
  controller: ["$http", "$q", "$window", "cpConstants", "cpAPI", "scAnalytics", "scCurrencyService", "scDigitalWalletsService", "scThemesService", "scCampaignsService", function controller($http, $q, $window, cpConstants, cpAPI, scAnalytics, scCurrencyService, scDigitalWalletsService, scThemesService, scCampaignsService) {
    var _this = this;

    var theme = scThemesService.active.current;

    this.dataId = '';
    this.payLogo = '';
    this.payType = '';
    this.showDigitalWallets = false;
    this.useAnotherPaymentBtnStyle = {
      color: theme.styles.primaryColor,
      border: '2px solid ' + theme.styles.primaryColor
    };

    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currency = _this.currency || scCurrencyService.getDefaultCurrency();
              _this.amount = _this.amount || 0;
              _this.classyMode = _this.classyMode || scCampaignsService.active.current.classy_mode_enabled;

              if (scDigitalWalletsService.isLoaded) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return _this.initDW();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    this.$onChanges = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(changes) {
        var updateParams;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(changes.currency && changes.currency.isFirstChange())) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (!isNaN(_this.amount)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                if (scDigitalWalletsService.isLoaded) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this.initDW();

              case 7:
                _context2.next = 10;
                break;

              case 9:
                if (_this.amount !== 0) {
                  updateParams = {
                    amount: _this.amount,
                    frequency: _this.frequency,
                    currency: _this.currency,
                    fot: _this.fot,
                    classyMode: _this.classyMode,
                    submit: _this.submit
                  };

                  scDigitalWalletsService.updatePaymentRequest(updateParams);
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    this.digitalWalletsEnabled = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var PAYMENT_METHODS, processors;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              PAYMENT_METHODS = cpConstants.PAYMENT_METHODS;
              _context3.next = 3;
              return _this.getProcessors();

            case 3:
              processors = _context3.sent;
              return _context3.abrupt('return', PAYMENT_METHODS.DW in processors);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    this.getProcessors = function () {
      if ($window.SC.processors) return $q.resolve($window.SC.processors);

      return $http.get('/frs-api/pay/processors?appId=' + cpAPI.getApplicationId()).then(function (response) {
        return response.data;
      });
    };

    this.showDigitalWalletsListener = function (show) {
      _this.showDigitalWallets = show;
      if (show) {
        _this.determineLogo(scDigitalWalletsService.isApplePay);
        _this.setDataId();
      }
    };

    this.setDataId = function () {
      switch (_this.payType) {
        case 'Apple Pay':
          _this.dataId = 'paymethod-applepay';
          break;
        case 'Google Pay':
          _this.dataId = 'paymethod-googlepay';
          break;
        case 'Microsoft Pay':
          _this.dataId = 'paymethod-microsoftpay';
          break;
        default:
          _this.dataId = '';
          break;
      }
    };

    this.initDW = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.digitalWalletsEnabled();

            case 2:
              if (!_context4.sent) {
                _context4.next = 6;
                break;
              }

              scDigitalWalletsService.initDigitalWallets({
                currency: _this.currency,
                frequency: _this.frequency,
                amount: _this.amount,
                fot: _this.fot,
                classyMode: _this.classyMode,
                submit: _this.submit
              });
              _context4.next = 8;
              break;

            case 6:
              scAnalytics.track('dw_loaded', { digitalWalletsLoaded: false });
              scDigitalWalletsService.showDigitalWallets(false);

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    scDigitalWalletsService.addShowDigitalWalletsListener(this.showDigitalWalletsListener);

    this.determineLogo = function (isApplePay) {
      /**
       * Order is important here:
       * Edge's User agent includes "Chrome", but Chrome does not have "Edge"
       * Chrome's User agent includes Safari, better to rely on Stripe to tell us if the button should be apple pay
       */
      var isChrome = navigator.userAgent.indexOf('Chrome') !== -1;
      var isEdge = navigator.userAgent.indexOf('Edg') !== -1;

      if (isChrome) {
        _this.payLogo = '/static/global/images/digitalWallets/GooglePay-logo.svg';
        _this.payType = 'Google Pay';
      }

      if (isEdge) {
        _this.payLogo = '/static/global/images/digitalWallets/MicrosoftPay-logo.svg';
        _this.payType = 'Microsoft Pay';
      }

      if (isApplePay) {
        _this.payLogo = '/static/global/images/digitalWallets/ApplePay-logo.svg';
        _this.payType = 'Apple Pay';
      }
    };

    this.openDWModal = scDigitalWalletsService.openDWModal;
  }]
});
})();